/**
 * Created by Administrador on 17/11/2017.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('subClassificationCtrl', subClassificationCtrl)
        .controller('newEditSubClassificationCtrl', newEditSubClassificationCtrl)
        .controller('deleteSubClassificationCtrl', deleteSubClassificationCtrl);

    subClassificationCtrl.$inject = ['linkService', 'tabs','subClassifications','fareSubClassifications'];

    newEditSubClassificationCtrl.$inject = ['tabs', 'subClassificationService', 'linkService', 'subClassification',
        'action','classifications','fareSubClassifications'];

    deleteSubClassificationCtrl.$inject = ['subClassification', 'subClassificationService', '$uibModalInstance','linkService'];

    function subClassificationCtrl(linkService, tabs, subClassifications, fareSubClassifications){
        var vm = this;
        vm.tabs = tabs;
        vm.pages = subClassifications.data.page;
        vm.subClassifications = (subClassifications.data._embedded) ? subClassifications.data._embedded.subClassifications : [];
        vm.fareSubClassifications = (fareSubClassifications.data._embedded) ? fareSubClassifications.data._embedded.fareSubClassifications : [];
        vm.linkService = linkService;

        angular.forEach(vm.subClassifications, function(subClassification){
            angular.forEach(vm.fareSubClassifications, function(fareSubClassification){
                if(vm.linkService.getLinkId(fareSubClassification._embedded.subClassification._links.self.href)==
                    vm.linkService.getLinkId(subClassification._links.self.href)){
                    subClassification.fareClassification = fareSubClassification;
                }
            })
        });
    }

    function newEditSubClassificationCtrl(tabs, subClassificationService, linkService, subClassification, action,
                                          classifications,fareSubClassifications){
        var vm = this;
        vm.tabs = tabs;
        vm.linkService = linkService;
        vm.subClassification = {
            rbcFareSubClassification: {
                percentage: 0,
                fixedAmount: 0,
                subClassificationId: 0
            }
        };
        vm.classifications = (classifications.data._embedded) ? classifications.data._embedded.classifications : [];

        if(action == 'edit'){
            vm.subClassification.lang = subClassification.data.lang;
            vm.subClassification.subClassificationId = vm.linkService.getLinkId(subClassification.data._links.self.href);
            vm.subClassification.classificationId = vm.linkService.getLinkId(subClassification.data._embedded.classification._links.self.href);

            if(fareSubClassifications.data._embedded){
                vm.subClassification.rbcFareSubClassification.percentage = fareSubClassifications.data._embedded.fareSubClassifications[0].percentage;
                vm.subClassification.rbcFareSubClassification.fixedAmount = fareSubClassifications.data._embedded.fareSubClassifications[0].fixedAmount;
            }
        }

        vm.saveSubClassification = function(isValid, subClassification){
            if (isValid) {
                subClassification.classificationId = parseInt(subClassification.classificationId);
                if(action == "new"){
                    subClassificationService.saveSubClassification(subClassification);
                }else{
                    subClassificationService.updateSubClassification(vm.subClassification.subClassificationId, vm.subClassification)
                }
            }
        }
    }

    function deleteSubClassificationCtrl(subClassification, subClassificationService, $uibModalInstance, linkService){
        var vm = this;

        vm.subClassification = subClassification.data;

        vm.deleteSubClassification = function(){
            subClassificationService.deleteSubClassification(linkService.getLinkId(subClassification.data._links.self.href))
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
